import ModelCreateModal from "components/ui/customs/generics/ModelCreateModal";
import ModelListPage from "components/ui/customs/generics/ModelListPage";
import MyOfficeHome from "./MyOfficeHome";

import MyOfficeLayout from "./MyOfficeLayout";
import ModelViewPage from "components/ui/customs/generics/ModelViewPage";

const myOfficeConfig = {
  type: "view",
  path: "myoffice",
  title: "MyOffice",
  Layout: <MyOfficeLayout />,
  Content: MyOfficeHome,
  subPages: [
    {
      type: "list",
      path: "google-groups",
      title: "Google Groups",
      keyName: "googleGroupId",
      Content: ModelListPage,
      modelName: "hr.GoogleGroup",
      itemCreateModal: ModelCreateModal({ modelName: "hr.GoogleGroup" }),
      itemPath: (x) => `${x.id}`,
      subPages: [
        {
          title: "Detail",
          pageTitle: (group) => `Google Group: ${group?.name || "New Group"}`,
          path: "detail",
          type: "view",
          Content: ModelViewPage,
        },
        {
          title: "Google Users",
          pageTitle: (group) => `Users in ${group?.name || "Google Group"}`,
          path: "users",
          type: "list",
          keyName: "googleUserId",
          Content: ModelListPage,
          modelName: "hr.GoogleUser",
          defaultFilter: (group) => {
            return {
              items: [{ field: "parents", operator: "is", value: group.id }],
            };
          },
        },
      ],
    },
    {
      type: "list",
      title: "Google Users",
      path: "google-users",
      keyName: "googleUserId",
      Content: ModelListPage,
      modelName: "hr.GoogleUser",
      itemCreateModal: ModelCreateModal({ modelName: "hr.GoogleUser" }),
      itemPath: (x) => `${x.id}`,
    },
  ],
};

export default myOfficeConfig;
